import nacl from 'tweetnacl';
import naclUtil from 'tweetnacl-util';

export type SupportSyncPayload = { summary: Record<string, unknown>; payloadSha512: string };

export const hashSupportSyncSummary = (summary: Record<string, unknown>): string =>
  naclUtil.encodeBase64(nacl.hash(naclUtil.decodeUTF8(JSON.stringify(summary))));

// O contrato v1 aceita o aviso de cofre, mas não este contador na raiz do resumo.
export const compatibleSupportSyncPayload = (original: SupportSyncPayload): SupportSyncPayload | null => {
  const count = original.summary.deferred_media_cleanup;
  if (!Number.isInteger(count) || Number(count) < 0 ||
      hashSupportSyncSummary(original.summary) !== original.payloadSha512) return null;
  const { deferred_media_cleanup: _count, ...summary } = original.summary;
  return { summary, payloadSha512: hashSupportSyncSummary(summary) };
};
